import { Text } from '@react-pdf/renderer';
import { getSimpleFontFamily } from '../../../utils/fontRegistry';

/**
 * ChineseText - React PDF Text组件的直接替代品
 * 基于官方文档的Font.registerHyphenationCallback方法
 * 解决中文文本换行和连字符问题
 */
const ChineseText = ({
  children,
  style = {},
  fontFamily,
  ...props
}) => {
  // 最小化样式设置 - 只设置字体，其他完全由用户控制
  const textStyle = {
    fontFamily: fontFamily || getSimpleFontFamily(),
    ...style, // 用户样式完全覆盖默认设置
  };

  return (
    <Text
      style={textStyle}
      {...props}
    >
      {children}
    </Text>
  );
};



// 默认导出主要的ChineseText组件
export default ChineseText;
